import { CheckCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export default function Formulario2Confirmado() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center p-6">
      <Card className="max-w-2xl w-full bg-gray-800/50 border-gray-700">
        <CardHeader className="text-center pb-4">
          <div className="w-20 h-20 bg-green-500/10 border-2 border-green-500/30 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-green-500" />
          </div>
          <CardTitle className="text-3xl text-white mb-2">¡Formulario Recibido!</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-gray-300 text-lg">
            Tu información ha sido enviada exitosamente
          </p>
          <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-6">
            <p className="text-blue-400 font-medium mb-3">📋 Próximos Pasos</p>
            <p className="text-gray-300 text-sm leading-relaxed">
              Nuestro departamento gerencial revisará tu información y la cotejará con nuestros expedientes. 
              Te contactaremos pronto con los siguientes pasos para completar tu proceso de retiro.
            </p>
          </div>
          <p className="text-sm text-gray-500 mt-6">
            Si tienes alguna pregunta, contáctanos a: soporte@kompa.global
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
